<template>
  <sa-page-layout :btnSaveVisible="false" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData"
    @beforeSave="onBeforeSave" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
    <template slot="toolbar">
      <b-button variant="success btn-toolbar float-sm-right sa-margin-right" @click="onSaveClose">
        <b-icon icon="check2"></b-icon>
        Salva e Chiudi
      </b-button>
    </template>
    <template slot="table-body">
      <graffidi-device-edit-component :showModalLoading="showModalLoading" @update="onUpdateJsonData"
        @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></graffidi-device-edit-component>
    </template>
  </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GraffidiDeviceEditComponent from "../components/GraffidiDeviceEditComponent.vue";
import toast from "../../../template/layout/utility/sa-toast.js";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  components: { SaPageLayout, GraffidiDeviceEditComponent },
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      linkback: "/graffididevice",
      jsonData: {
        gestore: null,
        tipoFirma: null,
        codiceDispositivo: null,
        descrizioneDispositivo: null,
        usernameAccount: null,
        passwordAccount: null,
        codiceStruttura: null,
        descrizioneStruttura: null,
        codiceUnitaOperativa: null,
        descrizioneUnitaOperativa: null,
      },
      showModalLoading: false,
      pathResource: "/digitalsigndevice",
    };
  },
  methods: {
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onBeforeSave() {
      return;

    },
    onSaveClose() {
      this.openShowModalLoading();
      let validation = this.validation();
      if (!validation.esito) {
        toast.validation(validation)
        this.closeShowModalLoading();
        return;
      }
      let link = process.env.VUE_APP_PATH_API + "/digitalsigndevice";

      if (this.jsonData.primaryKey) {
        axios.put(link + "/" + this.jsonData.primaryKey, this.jsonData).then((response) => {
          toast.success("Modifica Dispositivo ' " + response.data.data.descrizioneDispositivo + " '");
          this.$router.push("/graffididevice")
          this.closeShowModalLoading();
        }).catch((err) => {
          this.closeShowModalLoading();
          toast.error(err.response.data.messaggio)
        });
      } else {
        axios.post(link, this.jsonData).then((response) => {
          toast.success("Creazione Dispositivo ' " + response.data.data.descrizioneDispositivo + " '");
          this.$router.push("/graffididevice")
          this.closeShowModalLoading();
        }).catch((err) => {
          this.closeShowModalLoading();
          toast.error(err.response.data.messaggio)
        });
      }
    },
    validation() {
      let esito = true;
      let msg = "";
      if (this.jsonData.gestore == null || this.jsonData.gestore == "") {
        msg += "Seleziona Gestore ! #";
        esito = false;
      }
      if (this.jsonData.tipoFirma == null || this.jsonData.tipoFirma == "") {
        msg += "Seleziona Tipo Firma ! #";
        esito = false;
      }
      if (this.jsonData.codiceDispositivo == null || this.jsonData.codiceDispositivo == "") {
        msg += "Inserire Codice Dispositivo ! #";
        esito = false;
      }
      if (this.jsonData.descrizioneDispositivo == null || this.jsonData.descrizioneDispositivo == "") {
        msg += "Inserire Descrizione Dispositivo ! #";
        esito = false;
      }
      if (this.jsonData.codiceStruttura == null || this.jsonData.codiceStruttura == "") {
        msg += "Inserire Codice Struttura ! #";
        esito = false;
      }
      if (this.jsonData.descrizioneStruttura == null || this.jsonData.descrizioneStruttura == "") {
        msg += "Inserire Descrizione Struttura ! #";
        esito = false;
      }
      if (this.jsonData.codiceUnitaOperativa == null || this.jsonData.codiceUnitaOperativa == "") {
        msg += "Inserire Codice Unità Operativa ! #";
        esito = false;
      }
      if (this.jsonData.descrizioneUnitaOperativa == null || this.jsonData.descrizioneUnitaOperativa == "") {
        msg += "Inserire Unità Operativa ! #";
        esito = false;
      }
      if (this.jsonData.usernameAccount == null || this.jsonData.usernameAccount == "") {
        msg += "Inserire Username Account ! #";
        esito = false;
      }
      if (this.jsonData.passwordAccount == null || this.jsonData.passwordAccount == "") {
        msg += "Inserire Password Account ! #";
        esito = false;
      }


      return { esito: esito, msg: msg };
    },
  },
};
</script>

<style></style>
